import sheet from './sheet.jpg';
import bedLinen1 from './bed-linen-1.jpg';
import bedLinen2 from './bed-linen-2.jpg';
import bedLinen3 from './bed-linen-3.jpg';
import blob1 from './blob-1.png';
import blob2 from './blob-2.png';
import blob3 from './blob-3.png';
import blob4 from './blob-4.png';
import blob5 from './blob-5.png';
import blob6 from './blob-6.png';

export default {
  sheet,
  bedLinen1,
  bedLinen2,
  bedLinen3,
  blob1,
  blob2,
  blob3,
  blob4,
  blob5,
  blob6,
};
